import React, { useState, useEffect } from 'react';
import { getHowYouMeet } from '../../services/api';

export default function HowYouMeet({ onHowYouMeetChange }) {
  const [selectedOption, setSelectedOption] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHowYouMeet = async () => {
      try {
        const response = await getHowYouMeet();
        setOptions(response);
      } catch (error) {
        console.error('Error fetching how you meet options:', error);
        // Fallback a opciones hardcodeadas
        setOptions([
          { id_forma_conocernos: '1', forma_conocernos: 'Referencia' },
          { id_forma_conocernos: '2', forma_conocernos: 'Publicidad' },
          { id_forma_conocernos: '3', forma_conocernos: 'Internet' },
          { id_forma_conocernos: '4', forma_conocernos: 'Recomendación' },
          { id_forma_conocernos: '5', forma_conocernos: 'Otro' },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchHowYouMeet();
  }, []);

  const handleChange = e => {
    const value = e.target.value;
    setSelectedOption(value);
    if (onHowYouMeetChange) {
      onHowYouMeetChange(value);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500">
        Cargando opciones...
      </div>
    );
  }

  return (
    <div className="relative">
      <select
        value={selectedOption}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none bg-white"
      >
        <option value="" disabled>
          Como conociste Iustia
        </option>
        {options.map(option => (
          <option key={option.id_forma_conocernos} value={option.id_forma_conocernos}>
            {option.forma_conocernos}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
}
